var backToTop = document.querySelector('.g-backToTop');
window.addEventListener('scroll', function () {
  var scrolling = window.scrollY || document.body.scrollTop || window.pageYOffset;

  if (scrolling > window.innerHeight) {
    backToTop.classList.add('g-active');
  } else {
    backToTop.classList.remove('g-active');
  }
});


//hack
if (window.location.href.indexOf('tools-resources') > -1) {
  document.querySelector('.m-Main .m-Menu>li.m-MenuItem:nth-child(4)').classList.add('menu-item--active-trail');
}

//vimeo
if (document.getElementById('howToVideo') || document.getElementById('TrainingKit')) {
  var videoPlayer = new Vimeo.Player('howToVideo');
  videoPlayer.on('play', function () {
    console.log('Played the video');
  });

  var videoPlayer2 = new Vimeo.Player('TrainingKit');
  videoPlayer2.on('play', function () {
    console.log('Played the video');
  });
}



//targets all links with hash
jQuery(document).ready(function () {
  var urlHash = window.location.hash;
  if (urlHash.length > 0) {
    jQuery('html,body').animate({
      scrollTop: jQuery(urlHash).offset().top
    }, 3000);
  }

  jQuery(".school_nurse_info").click(function () {
    window.location.href = '/healthcare-professionals/school-nurses';
  })

  jQuery(".back_to_school_image_block img").click(function () {
    window.open(
      '/US-P-NZ-SC-2100108_Get_Back_to_Class.pdf',
      '_blank'
    );
  })

});

var href = window.location.href;
  if(href.indexOf("/how-to-use-nayzilam") > -1){
       $("body").addClass("how-to-use-nayzilam"); 
  }

  if(href.indexOf("/what-is-nayzilam") > -1){
    $("body").addClass("what-is-nayzilam");
}



(function (Drupal, $) {

  'use strict';

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.detectIfChecked = {
    attach: function (context, settings) {

      $(`.webform-submission-unsubscribe-form .webform-buttons--wrapper input,
        .webform-submission-savings-card-form .webform-buttons--wrapper input,
        .webform-submission-consumer-sign-up-form .webform-buttons--wrapper input`).each(function () {
        $(this).change(function () {
          $(this).parent().parent().find('label').removeClass('active');
              if ($(this).next('label').hasClass('active')) {
                $(this).next('label').removeClass('active');
              } else {
                $(this).next('label').addClass('active');
              }
        })
      })
    }
  };

})(Drupal, jQuery);
